<template>
  <div class="app-footer">
    <div class="license">Copyright © Big Field Global PTE. Ltd. All rights reserved.</div>
  </div>
</template>

<script>
export default {
  name: 'AppFooter'
};
</script>

<style>
.app-footer {
  margin-top: 40px;
}
.app-footer .license {
  font-size: 12px;
  padding: 10px 0;
  color: #fff;
  text-align: center;
  background-color: #4acbd6;
}
</style>
